import { render } from "./QRcodeGen.vue?vue&type=template&id=04a0fae3&scoped=true"
import script from "./QRcodeGen.vue?vue&type=script&lang=js"
export * from "./QRcodeGen.vue?vue&type=script&lang=js"

import "./QRcodeGen.vue?vue&type=style&index=0&id=04a0fae3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a0fae3"]])

export default __exports__